import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { OpportunityFormResponse } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

type QueryKey = [string];

export function useOpportunityFormSchema(
  options?: UseQueryOptions<OpportunityFormResponse, unknown, OpportunityFormResponse, QueryKey>,
) {
  const api = useIntegrationApi();
  return useQuery(
    ["opportunityFormSchema"],
    async () => {
      const response = await api.opportunityFormSchema();
      return response;
    },
    options,
  );
}
